// Banner Configuration Data
// Premium design system - easy to update for future campaigns

export const BANNER_BRANDS = {
  FUNBET_ME: 'funbet_me',
  FUNBET_AI: 'funbet_ai',
  TELEGRAM: 'telegram',
};

export const BANNER_SLOTS = {
  TOP: 'top_banner',
  MID_PAGE: 'mid_page_banner',
  STICKY_FOOTER: 'sticky_footer_banner',
  INLINE: 'inline_banner',
};

export const BANNER_CONFIGS = {
  [BANNER_BRANDS.FUNBET_ME]: {
    id: 'funbet_me',
    brand: 'FunBet.Me',
    headline: 'Bet Smarter with FunBet.Me',
    subheadline: 'Premium odds • Instant payouts • Live betting',
    cta: 'Start Betting',
    url: 'https://funbet.me',
    colors: {
      primary: '#22c55e',
      secondary: '#16a34a',
      accent: '#86efac',
    },
    priority: 'betting',
  },
  [BANNER_BRANDS.FUNBET_AI]: {
    id: 'funbet_ai',
    brand: 'FunBet.ai',
    headline: 'AI-Powered Odds Comparison',
    subheadline: 'Smart predictions • Value finder • Real-time insights',
    cta: 'Explore',
    url: 'https://funbet.ai',
    colors: {
      primary: '#3b82f6',
      secondary: '#2563eb',
      accent: '#93c5fd',
    },
    priority: 'prediction',
  },
  [BANNER_BRANDS.TELEGRAM]: {
    id: 'telegram',
    brand: 'Telegram',
    headline: 'Join 100,000+ Followers',
    subheadline: 'Get the latest bets, bonus & exclusive offers from FunBet.Me on Telegram',
    cta: 'Join Now',
    url: 'https://t.me/funbetDOTme',
    colors: {
      primary: '#0088cc',
      secondary: '#0077b5',
      accent: '#54a9eb',
    },
    priority: 'social',
    icon: 'telegram',
  },
};

// Page type detection
export const PAGE_TYPES = {
  HOME: 'home',
  PREDICTION: 'prediction',
  BETTING: 'betting',
  OTHER: 'other',
};

export const getPageType = (pathname) => {
  if (pathname.includes('/predictions/')) return PAGE_TYPES.PREDICTION;
  if (pathname === '/') return PAGE_TYPES.HOME;
  return PAGE_TYPES.OTHER;
};

export const getPrioritizedBanners = (pageType) => {
  const banners = Object.values(BANNER_CONFIGS);
  
  if (pageType === PAGE_TYPES.PREDICTION) {
    return banners.sort((a, b) => 
      a.priority === 'prediction' ? -1 : b.priority === 'prediction' ? 1 : 0
    );
  }
  
  if (pageType === PAGE_TYPES.HOME || pageType === PAGE_TYPES.BETTING) {
    return banners.sort((a, b) => 
      a.priority === 'betting' ? -1 : b.priority === 'betting' ? 1 : 0
    );
  }
  
  return banners;
};

export const ROTATION_CONFIG = {
  enabled: true,
  intervalMs: 10000, // 10 seconds for premium feel
  rotateOnPageLoad: true,
};

export default BANNER_CONFIGS;
